import axios from 'axios';
import {ACTIONS} from "./index";
import {API_CONFIGS, AXIOS_CONFIG_S3} from "../configs";

export function syncFileToS3(postId) {
    const axiosInstance = axios.create(AXIOS_CONFIG_S3());
    const request = axiosInstance.post(API_CONFIGS.SYNC_TO_S3(postId));

    return {
        type: ACTIONS.SYNC_TO_S3,
        payload: request
    }
}

export function unSyncFileFromS3(postId) {
    const axiosInstance = axios.create(AXIOS_CONFIG_S3());
    const request = axiosInstance.post(API_CONFIGS.UN_SYNC_TO_S3(postId));

    return {
        type: ACTIONS.SYNC_TO_S3,
        payload: request
    }
}

export function checkStatusFile(postId) {
    const axiosInstance = axios.create(AXIOS_CONFIG_S3());
    const request = axiosInstance.post(API_CONFIGS.CHECK_FILE_IS_DELETED_AND_SYNC(postId));

    return {
        type: ACTIONS.CHECK_STATUS_FILE,
        payload: request
    }
}